import { useCallback } from 'react';

import { useSendMessage } from '@lemon/chats';

export const useChatMessage = (nodeId: string | undefined, roomId: string | undefined) => {
    const { mutateAsync: sendMessage, isPending } = useSendMessage();

    const sendHttpMessage = useCallback(
        async (text: string) => {
            if (!nodeId || !roomId) return;

            return await sendMessage({
                nodeId,
                roomId,
                message: text,
            });
        },
        [nodeId, roomId, sendMessage]
    );

    return {
        sendHttpMessage,
        isSending: isPending,
    };
};
